import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { useStaticQuery, graphql } from 'gatsby'
import {
  Button,
  Container,
  SectionTitle,
  Section,
  ListItem,
} from 'chaoskit/src/components'
import { merge } from 'lodash'
import { tealDarkBlue } from 'chaoskit/src/assets/styles/utility/gradient'

import LogoList from '../global/LogoList'

import Data from '~components/Data'
import { ReactComponent as AmazonSVG } from '~media/logos/amazon.svg'
import { ReactComponent as NetflixSVG } from '~media/logos/netflix.svg'
import { ReactComponent as SalesforceSVG } from '~media/logos/salesforce.svg'

const TeamIntro = ({ cta = {}, heading }) => {
  const theme = useTheme()

  const {
    file: {
      childMdx: { frontmatter: pageData },
    },
  } = useStaticQuery(graphql`
    query TeamIntroPageData {
      file(
        name: { eq: "index-LEGACY" }
        absolutePath: { regex: "/src/data/" }
      ) {
        childMdx {
          frontmatter {
            team {
              heading
              cta {
                label
                url
              }
            }
          }
        }
      }
    }
  `)

  // Combine pageData and props passed in to get proper values
  const mergedData = merge(pageData.team, { cta, heading })

  // If we have both an cta.onClick prop and cta.url prop; remove cta.url prop since onClick is the outlier
  if (mergedData.cta && mergedData.cta.onClick && mergedData.cta.url) {
    mergedData.cta.url = null
  }

  return (
    <Section
      space="xlarge"
      css={{
        ...tealDarkBlue(theme),
        svg: {
          filter: 'brightness(0) invert(1)',
        },
      }}
      className="u-contrast"
    >
      <Container>
        <SectionTitle title={<Data>{mergedData.heading}</Data>} />
        <LogoList>
          <ListItem>
            <AmazonSVG className="G__LogoList--amazon" />
          </ListItem>
          <ListItem>
            <NetflixSVG />
          </ListItem>
          <ListItem>
            <SalesforceSVG />
          </ListItem>
        </LogoList>
        {mergedData.cta && (
          <div css={{ marginTop: theme.space.xlarge, textAlign: 'center' }}>
            <Button
              onClick={mergedData.cta.onClick && mergedData.cta.onClick}
              url={mergedData.cta.url}
              type="default"
            >
              <Data>{mergedData.cta.label}</Data>
            </Button>
          </div>
        )}
      </Container>
    </Section>
  )
}

TeamIntro.propTypes = {
  cta: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    onClick: PropTypes.func,
  }),
  heading: PropTypes.string,
}

export default TeamIntro
